<template>
	<div>
		<v-h2>{{ blok.cta_title }}</v-h2>

		<p class="mt-md font-sans tracking-xl">
			{{ blok.cta_ingress }}
		</p>
	</div>
</template>

<script setup lang="ts">
defineProps<{
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	blok: any;
}>();
</script>
